import { render, staticRenderFns } from "./CategoryAutocomplete.vue?vue&type=template&id=4d6fb0b8&scoped=true"
import script from "./CategoryAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./CategoryAutocomplete.ts?vue&type=script&lang=ts&external"
import style0 from "./CategoryAutocomplete.scss?vue&type=style&index=0&id=4d6fb0b8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fb0b8",
  null
  
)

export default component.exports